import { render, staticRenderFns } from "./LoginLayer.vue?vue&type=template&id=156b00d6&scoped=true"
import script from "./LoginLayer.vue?vue&type=script&lang=js"
export * from "./LoginLayer.vue?vue&type=script&lang=js"
import style0 from "./LoginLayer.vue?vue&type=style&index=0&id=156b00d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b00d6",
  null
  
)

export default component.exports